export class PersonaNatural{
    idUsuario: any;
    idUnidad: any;
}